import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable, filter, map, shareReplay, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import * as LDClient from 'launchdarkly-js-client-sdk';

@Injectable({
  providedIn: 'root'
})
export class LaunchdarklyService {
  private launchDarklyClient$!: Observable<LDClient.LDClient>;

  public launchDarklyFlags$!: Observable<{ [key: string]: any }>;

  /**
   * Constructor.
   * @param authService To get user data.
   */
  constructor(private authService: AuthService) {
    this.initLaunchDarkly();
  }

  private initLaunchDarkly() {
    this.launchDarklyClient$ = this.authService.userData$.pipe(
      // filter(userData => !!userData?.isLoggedIn),
      map(userData => {
        const context: LDClient.LDContext = {
          key: userData.userName || 'anonymous',
          name: userData.userName || 'anonymous',
          country: userData.companyName || 'anonymous',
        };
        return LDClient.initialize(environment.launchDarklyClientId, context);
      }),
      shareReplay(1)
    );

    this.launchDarklyFlags$ = this.launchDarklyClient$.pipe(
      switchMap(client =>
        new Observable<{ [key: string]: any }>(subscriber => {
          client.on('ready', () => subscriber.next(client.allFlags()));
          client.on('change', () => subscriber.next(client.allFlags()));
        })
      ),
      shareReplay(1)
    );
  }
}
